var _ = require('./lodash.min').runInContext();
module.exports = require('./fp/_baseConvert')(_, _);



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/fp.js
// module id = 1086
// module chunks = 0